'use-strict';

import BackdropRailController, { BackdropItem } from '../bd-rail.controller';

/* @ngInject */
export default class BackdropRailItemController {
  private title!: string;

  private icon!: string;

  private item: BackdropItem = {
    active: false,
    icon: '',
    selected: false,
    title: '',
  };

  private bdRailController!: BackdropRailController;

  private $element: JQLite;

  constructor($element: JQLite) {
    this.$element = $element;
  }

  $onInit(): void {
    this.item = {
      active: false,
      selected: false,
      title: this.title,
      icon: this.icon,
    };
    this.bdRailController.registerItem(this.item, this.$element);
  }
}
